export default (diffs, years) => {
  const availableYears = diffs.map(diff => diff.year)
  const filledData = diffs.slice()
  for (const year of Array.from(years.keys())) {
    const y = parseInt(year, 10)
    if (availableYears.indexOf(y) < 0) {
      filledData.push({ year: y, diff: null })
    }
  }
  return filledData.sort((a, b) => a.year - b.year)
}